namespace TabAurous.Retail {
    export namespace FootfallAndSalesService {
        export const baseUrl = 'POSSales/FootfallAndSales';

        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<POSSalesItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "POSSales/FootfallAndSales/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>FootfallAndSalesService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
